"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentDescription = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const device_1 = require("@completeanatomy/device");
const i18n_1 = require("@completeanatomy/i18n");
const styled_components_1 = __importDefault(require("styled-components"));
function PaymentDescription({ currentPrice, regularPrice, }) {
    var _a, _b, _c, _d;
    const { isApple, isAndroid, isWindows } = (0, device_1.usePlatform)();
    let store;
    switch (true) {
        case isApple:
            store = 'iTunes';
            break;
        case isAndroid: {
            /**
             * @todo replace with app state
             */
            // @ts-ignore
            switch ((_a = window.config) === null || _a === void 0 ? void 0 : _a.androidStore) {
                // @ts-ignore
                case (_b = window.AndroidStore) === null || _b === void 0 ? void 0 : _b.Google:
                    store = 'Google';
                    break;
                // @ts-ignore
                case (_c = window.AndroidStore) === null || _c === void 0 ? void 0 : _c.Huawei:
                    store = 'Huawei AppGallery';
                    break;
                // @ts-ignore
                case (_d = window.AndroidStore) === null || _d === void 0 ? void 0 : _d.Tencent:
                    store = 'Tencent Appstore';
                    break;
                default:
                    store = 'Google';
            }
            break;
        }
        case isWindows:
            store = 'Microsoft';
            break;
    }
    return ((0, jsx_runtime_1.jsxs)(i18n_1.Trans, { i18nKey: i18n_1.Strings.store.buyDescription, tOptions: { currentPrice, regularPrice, store }, components: {
            p: (0, jsx_runtime_1.jsx)(StyledParagraph, {}),
        }, "data-e2e": 'PaymentDescription_Trans', children: [(0, jsx_runtime_1.jsxs)(StyledParagraph, { "data-e2e": 'PaymentDescription_StyledParagraph', children: ["Payment of ", currentPrice, " will be charged to your ", store, " Account at confirmation of purchase."] }), (0, jsx_runtime_1.jsx)(StyledParagraph, { "data-e2e": 'PaymentDescription_StyledParagraph', children: "Subscriptions are charged annually and automatically renew unless auto-renew is turned off at least 24-hours before the end of the current period." }), (0, jsx_runtime_1.jsxs)(StyledParagraph, { "data-e2e": 'PaymentDescription_StyledParagraph', children: ["Your ", store, " Account will be charged the current annual subscription cost of ", regularPrice, " each year for renewal within 24-hours prior to the end of the current period."] }), (0, jsx_runtime_1.jsxs)(StyledParagraph, { "data-e2e": 'PaymentDescription_StyledParagraph', children: ["You can manage your subscriptions and turn off auto-renewal by going to your ", store, " Account Settings any time after purchase. No refunds or credits given for any unused periods."] }), (0, jsx_runtime_1.jsx)(StyledParagraph, { "data-e2e": 'PaymentDescription_StyledParagraph', children: "Any free trial will be interrupted when a paid subscription is purchased." })] }));
}
exports.PaymentDescription = PaymentDescription;
const StyledParagraph = styled_components_1.default.p `
  margin-bottom: 1em;
`;
